import React, { useState } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
import { PricingSelector } from '../components/PricingSelector';
const testimonials = [{
  initials: 'CR',
  name: 'Carolina R.',
  location: 'Mendoza',
  product: 'Kit + PRO',
  quote: 'El módulo de fortalecimiento me cambió la perspectiva completamente. Siempre pensé que el problema era liberar la contractura. Pero sin fortalecer los músculos débiles que la generaban, volvía siempre. En 6 semanas de fortalecimiento las contracturas pasaron de ser semanales a ser ocasionales.'
}, {
  initials: 'RM',
  name: 'Rodrigo M.',
  location: 'Buenos Aires',
  product: 'Kit Esencial',
  quote: 'El Tomo 3 vale todo el precio del kit. Elevé el monitor con libros en 5 minutos y el dolor de cuello que tenía hace un año y medio bajó en 48 horas. Cuarenta y ocho horas. Sin hacer nada más que ajustar la altura de la pantalla.'
}, {
  initials: 'SC',
  name: 'Sabrina C.',
  location: 'La Plata',
  product: 'Kit + PRO',
  quote: 'Las técnicas del Módulo 2 con la pelota de tenis llegaron a lugares que mis manos nunca podían alcanzar. El nudo del trapecio que tenía hace meses cedió en la segunda sesión. Dos sesiones con una pelota de tenis que costó $800.'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  location: 'Neuquén',
  product: 'Kit Esencial',
  quote: 'El Bono 2 de sueño fue lo que faltaba. Hacía los ejercicios durante el día pero me despertaba igual con el cuello rígido. Cambié la posición para dormir según el bono y en tres días dejé de despertar con dolor. Tres días.'
}];
const faqs = [{
  q: '¿Sirve si trabajo desde casa y no en oficina?',
  a: 'Sí. El Tomo 3 tiene un capítulo completo específico para home office porque los errores del trabajo remoto son distintos a los de la oficina tradicional. El Módulo 4 del Kit PRO también incluye protocolos para trabajo híbrido.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. Al completar el pago recibís el acceso en menos de 5 minutos directamente en tu email. Podés leerlo en el teléfono, la tablet o la computadora. Sin esperas, sin envíos.'
}, {
  q: '¿Lo puedo implementar si tengo muy poco tiempo?',
  a: 'Sí. El sistema está diseñado para oficinistas reales con jornadas reales. El Protocolo de Mañana son 10 minutos. El de Mediodía son 7. El de Noche son 10. El Método 30-30 son 30 segundos cada media hora. Si tenés 27 minutos al día tenés suficiente para el sistema completo.'
}, {
  q: '¿Tiene garantía real?',
  a: '30 días sin preguntas. Si en 30 días de implementación honesta no considerás que vale lo que pagaste, escribís a soporte y te devolvemos el 100% sin formularios ni explicaciones. La tasa de devoluciones es menor al 1%.'
}, {
  q: '¿Sirve si el dolor es muy crónico o muy intenso?',
  a: 'Sí. El Kit PRO tiene un Módulo 1 específicamente diseñado para contracturas crónicas de más de 6 meses. Si tu dolor es muy intenso o antiguo, el Plan PRO es la opción más recomendada.'
}, {
  q: '¿Necesito equipamiento especial?',
  a: 'No. El Kit Base funciona completamente sin ningún equipamiento. El Kit PRO usa herramientas básicas que ya tenés en casa: una pelota de tenis, un rodillo de cocina o una botella de agua. La inversión máxima en herramientas es $3.500 ARS.'
}];
const costComparison = [{
  sin: 'Sin protocolo de liberación instalado',
  costo: 'Tensión que se acumula semana tras semana sin intervención específica'
}, {
  sin: 'Sin setup ergonómico correcto',
  costo: 'El ambiente de trabajo destruyendo tu cuerpo 8 horas al día, 5 días a la semana'
}, {
  sin: 'Sin sistema de fortalecimiento',
  costo: 'Desequilibrio muscular que garantiza que el dolor vuelva siempre'
}, {
  sin: 'Sin protocolo de sueño correcto',
  costo: 'Recuperación nocturna incompleta que hace que el dolor nunca termine de irse'
}, {
  sin: 'Sin alimentación anti-inflamatoria',
  costo: 'Inflamación sistémica que hace que el cuerpo duela más de lo que debería'
}, {
  sin: 'Sin intervención ahora',
  costo: 'Contracturas funcionales que se convierten en lesiones estructurales en 2 a 5 años'
}, {
  sin: 'Próximo lunes sin sistema',
  costo: 'El mismo dolor, el mismo ibuprofeno, el mismo ciclo'
}];
function FaqItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className={`bg-white border rounded-xl sm:rounded-2xl overflow-hidden shadow-sm transition-all ${open ? 'border-[#2D9596]' : 'border-[#D5DCE5]'}`} data-id="element-294">
      <button onClick={() => setOpen(!open)} aria-expanded={open} className="w-full flex items-center justify-between p-3 sm:p-5 md:p-6 text-left font-medium text-xs sm:text-base md:text-lg text-[#1A2433] hover:text-[#1E3A5F] transition-colors gap-2" style={{
      fontFamily: "'DM Serif Display', serif"
    }} data-id="element-295">
        <span className="leading-snug" data-id="element-296">{q}</span>
        <svg className={`w-4 h-4 sm:w-5 sm:h-5 text-[#2D9596] shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-297">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-298" />
        </svg>
      </button>
      <div className={`grid transition-all duration-300 ease-out ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-299">
        <div className="overflow-hidden" data-id="element-300">
          <div className="px-3 sm:px-5 md:px-6 pb-3 sm:pb-5 md:pb-6 text-[#4A5568] leading-snug sm:leading-relaxed text-[11px] sm:text-sm md:text-base border-t border-[#D5DCE5]" data-id="element-301">
            <div className="pt-2.5 sm:pt-4" data-id="element-302">{a}</div>
          </div>
        </div>
      </div>
    </div>;
}
function MobileCostAccordion() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <div className="md:hidden space-y-1.5" data-id="element-303">
      {costComparison.map((row, i) => {
      const isOpen = openIdx === i;
      return <button key={i} onClick={() => setOpenIdx(isOpen ? null : i)} className={`w-full text-left bg-white border rounded-xl p-3 transition-all ${isOpen ? 'border-[#1E3A5F] shadow-md' : 'border-[#D5DCE5]'}`} aria-expanded={isOpen} data-id="element-304">
            <div className="flex items-center justify-between gap-2" data-id="element-305">
              <div className="flex items-start gap-2 flex-1 min-w-0" data-id="element-306">
                <span className="text-[#1E3A5F] text-xs mt-0.5 shrink-0" data-id="element-307">
                  ❌
                </span>
                <span className="text-xs text-[#1A2433] font-medium leading-snug" data-id="element-308">
                  {row.sin}
                </span>
              </div>
              <svg className={`w-3.5 h-3.5 text-[#2D9596] shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-309">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-310" />
              </svg>
            </div>
            <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-2' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-311">
              <div className="overflow-hidden" data-id="element-312">
                <div className="pl-5 pt-1.5 border-t border-[#D5DCE5]" data-id="element-313">
                  <p className="text-[11px] text-[#4A5568] italic leading-snug pt-1.5" data-id="element-314">
                    {row.costo}
                  </p>
                </div>
              </div>
            </div>
          </button>;
    })}
    </div>;
}
export function TrustSection() {
  return <section className="py-8 md:py-24 bg-white border-t border-[#D5DCE5]" data-id="element-315">
      <div className="max-w-6xl mx-auto px-4" data-id="element-316">
        {/* Testimonials */}
        <div className="text-center mb-5 sm:mb-16" data-id="element-317">
          <div className="text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.3em] text-[#2D9596] font-bold uppercase mb-2 sm:mb-3" data-id="element-318">
            Historias reales
          </div>
          <h2 className="text-xl sm:text-3xl md:text-5xl text-[#1A2433] leading-tight" data-id="element-319">
            Más oficinistas que <span className="italic" data-id="element-320">ya lo tienen</span>
          </h2>
        </div>

        {/* Mobile testimonials — horizontal scroll */}
        <div className="md:hidden mb-8 -mx-4 px-4 overflow-x-auto snap-x snap-mandatory scrollbar-hide" data-id="element-321">
          <div className="flex gap-3 pb-2" style={{
          width: 'max-content'
        }} data-id="element-322">
            {testimonials.map((t, i) => <div key={i} className="snap-start bg-[#E8EDF3] border border-[#D5DCE5] rounded-2xl p-4 w-[280px] shrink-0" data-id="element-323">
                <div className="flex items-center gap-2.5 mb-2.5" data-id="element-324">
                  <div className="w-10 h-10 rounded-full bg-white text-[#1E3A5F] flex items-center justify-center font-bold text-xs border border-[#D5DCE5] shrink-0" data-id="element-325">
                    {t.initials}
                  </div>
                  <div className="min-w-0 flex-1" data-id="element-326">
                    <div className="text-[#2D9596] text-[10px] tracking-wider mb-0.5" data-id="element-327">
                      ★★★★★
                    </div>
                    <div className="text-[#1A2433] font-bold text-xs leading-tight" data-id="element-328">
                      {t.name}{' '}
                      <span className="text-[#4A5568] font-normal text-[10px]" data-id="element-329">
                        📍 {t.location}
                      </span>
                    </div>
                    <div className="text-[9px] text-[#1E3A5F] font-medium mt-0.5 italic truncate" data-id="element-330">
                      · {t.product}
                    </div>
                  </div>
                </div>
                <p className="text-[#4A5568] italic text-xs leading-snug" data-id="element-331">
                  "{t.quote}"
                </p>
              </div>)}
          </div>
          <div className="text-center text-[10px] text-[#4A5568] mt-2 italic" data-id="element-332">
            ← Deslizá para ver más →
          </div>
        </div>

        {/* Desktop testimonials grid */}
        <div className="hidden md:grid sm:grid-cols-2 gap-3 sm:gap-5 md:gap-6 max-w-4xl mx-auto mb-12 md:mb-28" data-id="element-333">
          {testimonials.map((t, i) => <div key={i} className="bg-[#E8EDF3] border border-[#D5DCE5] rounded-2xl p-4 sm:p-6 md:p-8 hover:border-[#2D9596] hover:-translate-y-0.5 transition-all" data-id="element-334">
              <div className="flex items-center gap-3 mb-3 sm:mb-5" data-id="element-335">
                <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-full bg-white text-[#1E3A5F] flex items-center justify-center font-bold text-sm sm:text-base md:text-xl border border-[#D5DCE5] shrink-0" data-id="element-336">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-337">
                  <div className="text-[#2D9596] text-xs tracking-wider mb-0.5" data-id="element-338">
                    ★★★★★
                  </div>
                  <div className="text-[#1A2433] font-bold text-xs sm:text-sm md:text-base" data-id="element-339">
                    {t.name}{' '}
                    <span className="text-[#4A5568] font-normal text-[10px] sm:text-xs md:text-sm ml-0.5" data-id="element-340">
                      📍 {t.location}
                    </span>
                  </div>
                  <div className="text-[10px] sm:text-xs text-[#1E3A5F] font-medium mt-0.5 italic truncate" data-id="element-341">
                    · {t.product}
                  </div>
                </div>
              </div>
              <p className="text-[#4A5568] italic text-xs sm:text-sm md:text-base leading-relaxed" data-id="element-342">
                "{t.quote}"
              </p>
            </div>)}
        </div>

        {/* Guarantee */}
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-[#E8EDF3] to-white border border-[#2D9596]/30 rounded-2xl md:rounded-3xl p-5 sm:p-8 md:p-14 text-center mb-8 md:mb-28 relative overflow-hidden shadow-md" data-id="element-343">
          <div className="absolute top-0 left-0 w-full h-1 sm:h-1.5 bg-gradient-to-r from-[#2D9596] via-[#5BB5B5] to-[#2D9596]" data-id="element-344" />
          <div className="text-4xl sm:text-6xl md:text-7xl mb-3 sm:mb-6" data-id="element-345">
            🛡️
          </div>
          <div className="text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.3em] text-[#2D9596] font-bold uppercase mb-1.5 sm:mb-3" data-id="element-346">
            Garantía
          </div>
          <h2 className="text-xl sm:text-3xl md:text-5xl text-[#1A2433] mb-3 sm:mb-5 leading-tight" data-id="element-347">
            30 Días <span className="italic" data-id="element-348">Sin Preguntas</span>
          </h2>
          <p className="text-xs sm:text-base md:text-lg text-[#4A5568] mb-3 sm:mb-6 leading-snug sm:leading-relaxed" data-id="element-349">
            Abrís los tomos, los implementás y si en 30 días no considerás que
            vale al menos 10 veces lo que pagaste:{' '}
            <strong className="text-[#1E3A5F] italic" data-id="element-350">
              devolución del 100%
            </strong>
            . Sin formularios, sin drama.
          </p>
          <div className="inline-block bg-white px-3 py-1.5 sm:px-5 sm:py-2.5 rounded-full text-[#1E3A5F] font-medium border border-[#D5DCE5] text-[10px] sm:text-sm" data-id="element-351">
            Tasa de devoluciones: menos del 1%.
          </div>
        </div>

        {/* FAQ */}
        <div className="max-w-3xl mx-auto mb-8 md:mb-28" data-id="element-352">
          <div className="text-center mb-5 sm:mb-12" data-id="element-353">
            <div className="text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.3em] text-[#2D9596] font-bold uppercase mb-2 sm:mb-3" data-id="element-354">
              FAQ
            </div>
            <h2 className="text-xl sm:text-3xl md:text-5xl text-[#1A2433] leading-tight" data-id="element-355">
              Lo que más <span className="italic" data-id="element-356">nos preguntan</span>
            </h2>
          </div>
          <div className="space-y-2 sm:space-y-4" data-id="element-357">
            {faqs.map((faq, i) => <FaqItem key={i} q={faq.q} a={faq.a} data-id="element-358" />)}
          </div>
        </div>

        {/* Cost Comparison */}
        <div className="max-w-4xl mx-auto mb-8 md:mb-28" data-id="element-359">
          <h2 className="text-xl sm:text-3xl md:text-5xl text-[#1A2433] text-center mb-5 sm:mb-12 leading-tight" data-id="element-360">
            ¿Cuánto cuesta{' '}
            <span className="italic text-[#1E3A5F]" data-id="element-361">no tenerlo</span>?
          </h2>

          {/* Mobile accordion */}
          <MobileCostAccordion data-id="element-362" />

          {/* Desktop table */}
          <div className="hidden md:block bg-white border border-[#D5DCE5] rounded-2xl md:rounded-3xl overflow-hidden shadow-md" data-id="element-363">
            <div className="overflow-x-auto" data-id="element-364">
              <table className="w-full text-left min-w-[480px]" data-id="element-365">
                <thead data-id="element-366">
                  <tr className="bg-[#E8EDF3]" data-id="element-367">
                    <th className="p-3 sm:p-4 md:p-6 text-[#1A2433] font-bold text-[10px] sm:text-xs uppercase tracking-wider border-b border-[#D5DCE5] w-1/2" data-id="element-368">
                      Sin Kit Anticontracturas
                    </th>
                    <th className="p-3 sm:p-4 md:p-6 text-[#1E3A5F] font-bold text-[10px] sm:text-xs uppercase tracking-wider border-b border-[#D5DCE5] w-1/2" data-id="element-369">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-370">
                  {costComparison.map((row, i) => <tr key={i} className="border-b border-[#D5DCE5] hover:bg-[#E8EDF3]/50 transition-colors" data-id="element-371">
                      <td className="p-3 sm:p-4 md:p-6 text-[#1A2433] font-medium text-xs sm:text-sm" data-id="element-372">
                        {row.sin}
                      </td>
                      <td className="p-3 sm:p-4 md:p-6 text-[#4A5568] text-xs sm:text-sm italic" data-id="element-373">
                        {row.costo}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="max-w-4xl mx-auto text-center bg-gradient-to-br from-[#E8EDF3] to-white border border-[#1E3A5F]/20 rounded-2xl md:rounded-3xl p-4 sm:p-6 md:p-10 relative overflow-hidden shadow-xl" data-id="element-374">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-xl h-[300px] rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(45,149,150,0.18) 0%, transparent 70%)'
        }} data-id="element-375" />

          <h2 className="text-2xl sm:text-4xl md:text-6xl text-[#1A2433] mb-4 sm:mb-6 relative z-10 leading-tight" data-id="element-376">
            El próximo lunes <span className="italic" data-id="element-377">puede ser diferente</span>
            .
          </h2>

          <div className="mb-4 sm:mb-8 relative z-10" data-id="element-378">
            <div className="text-[#1E3A5F] font-bold mb-2.5 sm:mb-4 uppercase tracking-[0.2em] sm:tracking-[0.25em] text-[9px] sm:text-xs" data-id="element-379">
              ⏰ El precio cierra en:
            </div>
            <CountdownTimer data-id="element-380" />
          </div>

          <div className="relative z-10" data-id="element-381">
            <PricingSelector data-id="element-382" />
          </div>
        </div>
      </div>
    </section>;
}